import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasGradient"];
import React, { memo } from 'react';
import { default as DefaultIcon } from './Icon';
import IconGradient from './IconGradient';
var Icon = /*#__PURE__*/memo(function (_ref) {
  var hasGradient = _ref.hasGradient,
    props = _objectWithoutProperties(_ref, _excluded);
  return hasGradient ? /*#__PURE__*/React.createElement(IconGradient, props) : /*#__PURE__*/React.createElement(DefaultIcon, props);
});
export default Icon;